module.exports = __webpack_public_path__ + "static/media/lipo-checker.b7022fc9.png";